import { cn, formatMoney, formatPercent } from '@/lib/utils'
import { numberValue } from './numbers'

/** Dollar amount via the dashboard's `formatMoney`, with aligned digits. */
export function Money({ value, className }: { value: string | number | null | undefined; className?: string }) {
  return <span className={cn('font-medium tabular-nums', className)}>{formatMoney(value == null ? value : numberValue(value))}</span>
}

/**
 * Percentage via the dashboard's `formatPercent`. `value` is already a percent (23.5 → "23.5%"),
 * the shape the API sends as `margin_percent`.
 */
export function PercentValue({ value, className }: { value: string | number | null | undefined; className?: string }) {
  return <span className={cn('tabular-nums', className)}>{formatPercent(value == null ? value : numberValue(value))}</span>
}
